/**
 * Canonical profile handle contract (Issue #181).
 * Pattern: ^[a-z][a-z0-9_-]{1,148}[a-z0-9]$
 */

export const HANDLE_PATTERN = /^[a-z][a-z0-9_-]{1,148}[a-z0-9]$/;

export const HANDLE_HINT =
  "3–150 символів: малі латинські літери, цифри, _ та -. Починається з літери, закінчується літерою або цифрою. Має бути унікальним.";

export const HANDLE_PLACEHOLDER = "name_surname";

export function normalizeHandleInput(value) {
  if (value == null) return "";
  return String(value).toLowerCase();
}

/**
 * @returns {string|null} Ukrainian error message, or null when valid.
 */
export function validateHandle(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (!normalized) {
    return "Вкажіть ім'я посилання на сайті.";
  }
  if (!HANDLE_PATTERN.test(normalized)) {
    return "Ім'я посилання має містити 3–150 символів: починатися з малої латинської літери, закінчуватися літерою або цифрою, і містити лише a–z, 0–9, _ або -.";
  }
  return null;
}
